<div cdk-overlay-origin #origin="cdkOverlayOrigin">
  <ng-content select="[uiOverlayToggle]" />
</div>

<ng-template
  cdk-connected-overlay
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayDisableClose]="true"
  [cdkConnectedOverlayOpen]="(overlayOpen$ | ngrxPush)!"
  [cdkConnectedOverlayFlexibleDimensions]="true"
  [cdkConnectedOverlayViewportMargin]="16"
  (overlayKeydown)="handleKeydown($event)"
  (backdropClick)="close()"
>
  <div
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    class="overlay-content rounded mat-elevation-z8 my-2 overflow-auto"
  >
    <ng-template *ngTemplateOutlet="content"></ng-template>
  </div>
</ng-template>
